
import BarcodeRowMixin from '@/components/mixins/BarcodeRowMixin.vue'
import { MASKED_ANNOTATION } from '@/utils/constants'
import { IFileItem } from '@/utils/types'
import { Options } from 'vue-class-component'
import { Mixins, Prop } from 'vue-property-decorator'

@Options({ name: 'BarcodeRowImage' })
export default class BarcodeRowImage extends Mixins(BarcodeRowMixin) {
  @Prop({ type: Array }) readonly values?: Array<IFileItem>
  @Prop({ type: Boolean, default: false }) readonly hidden!: boolean

  get isMasked() {
    return this.values?.some((value) => value?.url === MASKED_ANNOTATION)
  }
}
